import { render, staticRenderFns } from "./FlowSubMp.vue?vue&type=template&id=1f38d785&"
import script from "./FlowSubMp.vue?vue&type=script&lang=js&"
export * from "./FlowSubMp.vue?vue&type=script&lang=js&"
import style0 from "./FlowSubMp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports